function usersAnswersTableSpecForSurvey(survey) {
	// Fill the headers with the survey question text
	const headers = ['Nom', 'Prénom'].concat(survey.questions.map((question) => question.text))

	// Create the spec to add each user answers
	return {
		table: 'users',
		headers,
		row: (user, data) => {
			// Get last user answers for this survey
			const answersLogs = data.userLogsByUserIdAndDataKey[user.id][survey.id]
			const answers = answersLogs && answersLogs[answersLogs.length - 1] && answersLogs[answersLogs.length - 1].answers

			return [
				'name',
				'first_name',
			].concat(survey.questions.reduce((list, question) => {
				if (!answers || !answers[question.id]) {
					list.push({
						value: '-',
					})
					return list
				}

				let answersList = (!Array.isArray(answers[question.id]) ? [answers[question.id]] : answers[question.id])

				switch (question.type.slug) {
					case 'closed':
					case 'likert':
						// Map answer ids to their text
						answersList = answersList.map((id) => survey.answerById[id] && survey.answerById[id].text)
						break
				}

				list.push({
					value: answersList.filter(s => !!s).join(', ') || '-',
				})

				return list
			}, []))
		},
	}
}

export default {
	name: 'Sondages',
	content(data) {
		// Create spec for each survey
		return data.surveys.reduce((content, survey) => {
			// Add the survey name
			const name = [survey.name, survey.title].filter(str => str || false).join(' - ')
			content.push({ text: name })
			content.push({})


			// Add a table with all answers for each user
			content.push(usersAnswersTableSpecForSurvey(survey))

			// Add empty lines
			content.push({})
			content.push({})

			return content
		}, [])
	},
}